/**
 * Faltante o sobrante de un ítem del remito contra lo pendiente de su línea de OC: lo que llegó (sanas + rotas) menos lo
 * pendiente. Es la misma regla que guarda el backend (backend/src/compras/remito-diferencias.ts); acá sólo se muestra.
 * Sin pendiente (remito sin OC), no hay nada que comparar.
 */
export function diferenciaRemito(
  pendiente: number | null | undefined, recibido: number, rotas: number,
): { tipo: 'faltante' | 'sobrante' | null; cantidad: number } {
  if (pendiente == null) return { tipo: null, cantidad: 0 };
  const diferencia = Math.round((recibido + rotas - pendiente) * 1e4) / 1e4;
  if (diferencia < 0) return { tipo: 'faltante', cantidad: -diferencia };
  if (diferencia > 0) return { tipo: 'sobrante', cantidad: diferencia };
  return { tipo: null, cantidad: 0 };
}
